export default {"src":"/_next/static/media/Apache JMeter.781495a5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};